var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgSgd = function SvgSgd(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\u65B0\u5E01@2x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "path-1",
    cx: 12,
    cy: 12,
    r: 12
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u9875\\u9762-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u672A\\u7ED1\\u5B9A-\\u9884\\u6C47\\u6B3E\\u9875\\u9762",
    transform: "translate(-256.000000, -348.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-3",
    transform: "translate(15.000000, 144.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-7",
    transform: "translate(0.000000, 171.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-6",
    transform: "translate(225.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u65B0\\u5E01",
    transform: "translate(16.000000, 33.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "\\u8499\\u7248",
    fill: "#D8D8D8",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-2",
    mask: "url(#mask-2)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-2.266406, -3.073828)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62",
    fill: "#FF4258",
    x: 0,
    y: 0,
    width: 36.72,
    height: 17.64
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "\\u8DEF\\u5F84",
    fill: "#F2F2F5",
    points: "0.000117936118 30.2669484 37.3268993 30.2669484 37.3268993 17.4413956 0.000117936118 17.4413956"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4",
    strokeWidth: 1,
    fill: "none",
    transform: "translate(7.135254, 5.973340)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.89894483,4.79953898 C2.89894483,2.73799419 4.1230574,0.966314943 5.8624436,0.128914898 C5.50815278,0.0644574492 5.1538298,2.34479103e-14 4.79950681,2.34479103e-14 C2.15813447,2.34479103e-14 -5.86197757e-14,2.15816663 -5.86197757e-14,4.79953898 C-5.86197757e-14,7.44091132 2.15813447,9.56688139 4.76721376,9.56688139 C5.12153674,9.56688139 5.50815278,9.53458834 5.8302792,9.43799866 C4.1230574,8.63273085 2.89894483,6.8610516 2.89894483,4.79953898 Z",
    id: "\\u8DEF\\u5F84",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "\\u8DEF\\u5F84",
    fill: "#FFFFFF",
    points: "8.08506768 0.934150547 8.37493321 1.77167925 9.2768872 1.77167925 8.53598034 2.31921376 8.82597454 3.15674246 8.08506768 2.64137235 7.37645388 3.15674246 7.63412285 2.31921376 6.92538039 1.77167925 7.82736654 1.77167925"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "\\u8DEF\\u5F84",
    fill: "#FFFFFF",
    points: "10.7586044 2.89907349 11.04847 3.76876658 11.9504561 3.76876658 11.2095171 4.2841367 11.4995113 5.1538298 10.7586044 4.60629529 10.0176976 5.1538298 10.3076596 4.2841367 9.56675274 3.76876658 10.4687389 3.76876658"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.37923788,2.89907349 L5.66919991,3.76876658 L6.57108957,3.76876658 L5.8302792,4.2841367 L6.12014474,5.1538298 L5.37923788,4.60629529 L4.67062408,5.1538298 L4.96058611,4.2841367 L4.21967925,3.76876658 L5.12153674,3.76876658 L5.37923788,2.89907349 Z M9.72783203,6.08798034 L10.0176976,6.92550905 L10.9196837,6.92550905 L10.1787769,7.47307572 L10.4687389,8.31060442 L9.72783203,7.79520214 L9.01921823,8.31060442 L9.2768872,7.47307572 L8.5682734,6.92550905 L9.47013089,6.92550905 L9.72783203,6.08798034 Z M6.44230333,6.08798034 L6.6999723,6.92550905 L7.6018298,6.92550905 L6.89321599,7.47307572 L7.15091713,8.31060442 L6.44230333,7.79520214 L5.70136431,8.31060442 L5.9913585,7.47307572 L5.25045164,6.92550905 L6.15230914,6.92550905 L6.44230333,6.08798034 Z",
    id: "Fill-5",
    fill: "#FFFFFF"
  }))))))))))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgSgd);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/SGD.60fb340e.svg";